import React, { useMemo } from 'react';

type InputElement = HTMLInputElement | HTMLTextAreaElement;

export function useInlineCompletion(
    value: string,
    completions: string[],
    onValueChange: (value: string) => void,
) {
    const completion = useMemo(() => {
        const trimmed = value.trim();
        if (!trimmed || completions.length === 0) return null;

        const lowerValue = value.toLowerCase();
        const match = completions.find((c) =>
            c.toLowerCase().startsWith(lowerValue),
        );

        if (match && match.toLowerCase() !== lowerValue) {
            return match;
        }
        return null;
    }, [value, completions]);

    const handleKeyDown = (
        e: React.KeyboardEvent<InputElement>,
        fallback: (e: React.KeyboardEvent<InputElement>) => void,
    ) => {
        if (completion && e.key === 'Tab') {
            e.preventDefault();
            onValueChange(completion);
            return;
        }
        fallback(e);
    };

    return { completion, handleKeyDown };
}
